<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('novo-fasefenologica') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(3)"
                                ref="idagrofasefenologicaerpInput"
                                v-model="fasefenologica.idagrofasefenologicaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!fasefenologica.idagrofasefenologicaerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="fasefenologica.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!fasefenologica.descricao"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                            />
                        </div>

                        <div class="column is-3">
                            <label for="situacao" v-text="$t('situacao')" />
                            <vss-select
                                :id="generateId(9)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="fasefenologica.id == null"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssFaseFenologicaService from '@/services/agro/FaseFenologicaService';
import FaseFenologicaService from '@/services/FaseFenologicaService';
import FaseFenologicaValidation from '@/services/validations/agro/FaseFenologicaValidation.js';
import Message from '@/models/Message';
import { mapState } from 'vuex';

export default {
    props: {
        idtipocultura: 0,
        permissaoVincular: false,
    },
    data() {
        return {
            service: new FaseFenologicaService(this.$http, this.$router),
            validation: new FaseFenologicaValidation(this.msgs),
            serviceAss: new AssFaseFenologicaService(this.$http, this.$routers),
            isLoading: false,
            msgs: [],
            isSaving: false,
            fasefenologica: {
                idagrofasefenologica: null,
                idagrofasefenologicaerp: '',
                descricao: '',
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'agro-fasefenologica'
            );
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-fasefenologica');
        }

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-fasefenologica` },
            });
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.fasefenologica, this.$refs)) {
                let Temp = Object.assign({}, this.fasefenologica);
                Temp = this.mapTosave(Temp);
                Temp.situacao = this.situacao.id;
                this.isSaving = true;
                this.service
                    .save(Temp, this.abrev)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-forma-pagamento';
                            if (this.fasefenologica.idagrofasefenologica != null) {
                                msg = 'msg-edit-formar-pagamento';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            if (this.promptConfirmaVinculo) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.$emit('fecharModal');
                            }
                        } else {
                            if (this.$te(value.message)) {
                                if (value.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(value.message, { n: this.fasefenologica.idagrofasefenologicaerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', value.message, true));
                                }
                            } else {
                                if (this.$t(value.message)) {
                                    this.msgs.push(new Message('alert', value.message, true));
                                } else {
                                    this.msgs.push(
                                        new Message('error', 'msg-problema-realizar-acao', true)
                                    );
                                }
                            }
                        }
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}-fasefenologica`,
                });
            }, 1000);
        },
        promptConfirmaVinculo(fasefenologica) {
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: (_) => {
                    this.realizarVinculo(fasefenologica);
                },
                onCancel: (_) => {
                    this.$emit('fecharModal', true);
                },
            });
        },
        realizarVinculo(fasefenologica) {
            let assTemp = [
                {
                    idagrofasefenologica: fasefenologica.idagrofasefenologica,
                    idtipocultura: this.idtipocultura,
                },
            ];

            this.serviceAss
                .save(assTemp)
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(new Message('error', `${value.message}`, true));
                    } else {
                        this.$emit('cadastrado');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
